"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ResolvedSection } from "@/utilities/data/getPlayersPageData";
import { CompetitionLeaderboardsBlock } from "./CompetitionLeaderboardsBlock";
import { PlayerListBlock } from "./PlayerListBlock";
interface Props {
  sections: ResolvedSection[];
  allowPlayerPhotos: boolean;
}
export const SectionRenderer: React.FC<Props> = t0 => {
  const $ = _c(7);
  const {
    sections,
    allowPlayerPhotos
  } = t0;
  let t1;
  if ($[0] !== allowPlayerPhotos || $[1] !== sections) {
    let t2;
    if ($[3] !== allowPlayerPhotos) {
      t2 = section => {
        if (section.type === "list") {
          return <PlayerListBlock key={section.key} section={section} allowPlayerPhotos={allowPlayerPhotos} />;
        }
        return <CompetitionLeaderboardsBlock key={section.key} competitionName={section.competitionName} competitionLogo={section.competitionLogo} leaderboards={section.leaderboards} brandedStyle={section.brandedStyle} allowPlayerPhotos={allowPlayerPhotos} />;
      };
      $[3] = allowPlayerPhotos;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = sections.map(t2);
    $[0] = allowPlayerPhotos;
    $[1] = sections;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <div className="flex flex-col">{t1}</div>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};